import { JsonProperty } from '../../../../models/utilities/json-property';
import { MailJobStatus } from '../enums/mailjob-status';

export class MailJobRead {

    public id               : number|undefined = undefined;
    public status           : MailJobStatus;
    public documentCount    : number = 0;
    public pageCount        : number = 0;

    @JsonProperty({ toType: 'datetime' })
    public createdOn        : Date;
    @JsonProperty({ toType: 'datetime' })
    public printedOn        : Date;

    constructor() {
        this.status = MailJobStatus.Open;
        this.createdOn = new Date();
        this.printedOn = new Date();
    }
}
